import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  isPlaying: false,
  duration: 0,
  currentTime: 0,
  volume: 1,
}

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.UPDATE_EXPORT_PREVIEW_PLAYING:
      return {
        ...state,
        isPlaying: action.isPlaying,
      }
    case FJActionConstant.SET_EXPORT_PREVIEW_DURATION:
      return {
        ...state,
        duration: action.duration,
      }
    case FJActionConstant.UPDATE_EXPORT_PREVIEW_CURRENT_TIME:
      return {
        ...state,
        currentTime: action.currentTime,
      }
    case FJActionConstant.UPDATE_EXPORT_PREVIEW_VOLUME:
      return {
        ...state,
        volume: action.volume,
      }
    default:
      return state;
  }
}
